import { connect } from 'react-redux';
import familyFilmClubModule from 'app/store/familyFilmClub';
import FamilyFilmClub from './BirthdayRoom.component';

const { requestBirthdayRoom } = familyFilmClubModule.actions;

const mapStateToProps = ({ familyFilmClub }) => ({
  content: familyFilmClub.birthdayRoom
});

const mapDispathToProps = {
  fetchContent: requestBirthdayRoom
};

export default connect(
  mapStateToProps,
  mapDispathToProps
)(FamilyFilmClub);
